import {
  AddUserRoles,
  AdminPermisions,
  basePlanUser,
  getAllOnBoardingCharge,
  getAllPermisions,
  getAllPlans,
  getAllUserRoles,
  getAllUserRolesDelete,
} from "api/api";
import InitialLoader from "components/InitilalLoader";
import MainComponent from "components/MainComponent";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Card, Button, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";

import "./Subscription.scss";
import { APP_DEFAULT_ROLES } from "utils/const";

const transformPermissionsToOptions = (permissions, selectedPermissions) => {
  if (!permissions) return [];

  const grouped = permissions.reduce((acc, permission) => {
    const group = permission.screen || "Other";
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(permission);
    return acc;
  }, {});

  return Object.entries(grouped).map(([screen, perms]) => ({
    label: screen,
    options: perms.map((perm) => ({
      value: perm.key,
      label: perm.option,
      isOptional: perm.isOptional,
      screen: perm.screen || "Other",
      combinedLabel: `${perm.screen || "Other"} - ${perm.option}`,
    })),
  }));
};

const Subscription = () => {
  const [additionalUser, setAdditionalUser] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [editBasePlan, setEditBasePlan] = useState("");
  const [basePlan, setBasePlan] = useState("");
  const [oneTimeCharge, setOneTimeCharge] = useState(0);
  const [allBasePlan, setAllBasePlan] = useState([]);
  const [pricePerAdditionalUser, setPricePerAdditionalUser] = useState("");
  const [setOnBoardingCharge] = useState();
  const [editOnBoarding, setEditOnBoarding] = useState(false);
  const [taxes, setTaxes] = useState([]);

  /**
   * user role state
   */
  const [selectUserRole, setSelectUserRole] = useState("");
  const [addUserRoles, setAddUserRoles] = useState("");
  const [userRole, setUserRole] = useState("");
  const [allUserRole, setAllUserRole] = useState([]);

  /**
   *user permisions state
   */
  const [selectPermision, setSelectPermision] = useState([]);
  const [allPermision, setAllPermision] = useState([]);

  /**
   *user screen state
   */
  const [selectScreen, setSelectScreen] = useState("");

  useEffect(() => {
    setAdditionalUser(allBasePlan?.baseplanUsers);
    setBasePlan(allBasePlan?.baseplanPrice);
    setOneTimeCharge(allBasePlan?.oneTimeSetupPrice);
    setPricePerAdditionalUser(allBasePlan?.pricePerAdditionalUser);
  }, [allBasePlan]);

  useEffect(() => {
    getAllPlans("/admin/baseplanuser")
      .then((response) => {
        setAllBasePlan(response?.data?.result);
        console.log("response", response);
        setIsLoading(false);
        return { error: null, response };
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response) {
          return { error: error.response };
        }
      });
  }, []);

  useEffect(() => {
    getAllOnBoardingCharge("/admin/baseplanuser/getOnBoardingCharge")
      .then((response) => {
        console.log("responseOnBoarding", response);

        setOnBoardingCharge(response?.data?.result);
        setIsLoading(false);
        return { error: null, response };
      })
      .catch((error) => {
        setIsLoading(false);
        console.log({ error });
        if (error.response) {
          return { error: error.response };
        }
      });
  }, []);

  const handleOnClickSave = () => {
    setIsLoading(true);
    const body = {
      // companyId: "0",
      baseplanUsers: additionalUser,
      baseplanPrice: basePlan,
      pricePerAdditionalUser: +pricePerAdditionalUser,
      oneTimeSetipPrice: oneTimeCharge,
    };
    setEditBasePlan(!editBasePlan);
    basePlanUser("/admin/baseplanuser", body)
      .then((response) => {
        setIsLoading(false);
        return { error: null, response };
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response) {
          return { error: error.response };
        }
      });
  };

  /**
   * user role
   */
  const handleOnClickSaveUserRole = async () => {
    try {
      setIsLoading(true);
      const body = {
        roleName: userRole,
      };
      const response = await AddUserRoles("/admin/permission/addrole", body);
      if (response?.data?.success) {
        setUserRole("");
        setAddUserRoles(false);
        toast.success("User role added successfully!");
      } else {
        toast.error(response?.data?.error);
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllUserRoles("/admin/permission/default-roles")
      .then((response) => {
        console.log("responseUserRole", response);
        setAllUserRole(response?.data?.result);

        return { error: null, response };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response };
        }
      });
  }, [isLoading]);

  const handleOnClickDeleteUserRole = () => {
    setIsLoading(true);

    const body = {
      isDeleted: true,
    };
    setAddUserRoles(addUserRoles);
    setSelectUserRole(!selectUserRole);
    getAllUserRolesDelete("/admin/permission/deleterole/", selectUserRole, body)
      .then((response) => {
        setIsLoading(false);

        return { error: null, response };
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response) {
          return { error: error.response };
        }
      });
  };

  const displaypTypeOptionsUserRoles = () => {
    return allUserRole?.map((elem, id) => {
      return (
        <option key={elem._id} value={elem._id}>
          {elem.name}
        </option>
      );
    });
  };

  /**
   *user permisions
   */
  useEffect(() => {
    getAllPermisions("/admin/permission/permissions")
      .then((response) => {
        setAllPermision(response?.data?.result);

        return { error: null, response };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response };
        }
      });
  }, [isLoading]);

  const increaseUser = (increase = true) => {
    let user = additionalUser;
    if (increase) {
      user += 1;
    } else {
      user -= 1;
    }
    setAdditionalUser(user);
  };

  const handleOnClickSaveAdminPermision = async () => {
    try {
      setIsLoading(true);
      const body = {
        permissions: selectPermision.map((p) => p.value),
        role: selectUserRole,
      };

      const response = await AdminPermisions(
        "/admin/permission/updateDefaultRole",
        body,
      );
      if (response?.data?.success) {
        setSelectUserRole("");
        setSelectPermision([]);
        toast.success("Permission updated successfully!");
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectUserRole = (role) => {
    setSelectUserRole(role);
    const selectedRole = allUserRole.find((r) => r._id === role);
    if (selectedRole) {
      const allSelectedPermision = allPermision
        .filter((p) => selectedRole.permissions.includes(p.key))
        .map((p) => ({
          value: p.key,
          label: p.option,
          isOptional: p.isOptional,
          screen: p.screen || "Other",
          combinedLabel: `${p.screen || "Other"} - ${p.option}`,
        }));
      setSelectPermision(allSelectedPermision);
    } else {
      setSelectPermision([]);
    }
  };

  const getIdx = (list, id) => list.findIndex((data) => data._id === id);

  const addTax = (data) => {
    setTaxes([...taxes, data]);
  };

  const editTax = (idx, data) => {
    taxes.splice(getIdx(taxes, idx), 1, data);
    setTaxes([...taxes]);
  };

  const deleteTax = (idx) => {
    taxes.splice(getIdx(taxes, idx), 1);
    setTaxes([...taxes]);
  };

  const handlePermissionChange = (selected) => {
    // If nothing is selected, allow clearing all
    if (!selected || selected.length === 0) {
      setSelectPermision([]);
      return;
    }

    // Get the newly selected/deselected option by comparing with current selection
    const newSelection = selected.find(
      (option) =>
        !selectPermision.find((existing) => existing.value === option.value),
    );

    if (newSelection) {
      // Adding a new selection
      if (newSelection.isOptional) {
        // If optional permission, simply add it
        setSelectPermision(selected);
        return;
      }

      // For non-optional permissions, enforce one per screen
      const updatedSelection = selectPermision.filter(
        (option) => option.isOptional || option.screen !== newSelection.screen,
      );

      // Add the new selection
      updatedSelection.push(newSelection);
      setSelectPermision(updatedSelection);
    } else {
      // Handling deselection
      const removedOption = selectPermision.find(
        (option) => !selected.find((newOpt) => newOpt.value === option.value),
      );

      if (!removedOption) return;

      // Allow deselection in all cases
      setSelectPermision(selected);
    }
  };

  return (
    <MainComponent>
      <div className="_container_right _user_page">
        {isLoading ? (
          <InitialLoader />
        ) : (
          <div className="p-4">
            <h3 className="mb-4">Subscription Management</h3>

            <Card className="mb-4">
              <Card.Header>
                <h5 className="mb-0">Base Plan Configuration</h5>
              </Card.Header>
              <Card.Body>
                <Row className="align-items-end">
                  <Col md={3}>
                    <Form.Group className="mb-0">
                      <Form.Label className="fw-semibold">
                        Base Plan Per Month
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>$</InputGroup.Text>
                        <Form.Control
                          type="number"
                          onChange={(e) => setBasePlan(e.target.value)}
                          value={basePlan}
                          disabled={!editBasePlan}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-0">
                      <Form.Label className="fw-semibold">
                        Number of Users in Base Plan
                      </Form.Label>
                      <div className="d-flex justify-content-start">
                        <InputGroup style={{ maxWidth: "180px" }}>
                          <Button
                            variant="secondary"
                            disabled={additionalUser === 1 || !editBasePlan}
                            onClick={() => increaseUser(false)}
                            style={{
                              height: "42px",
                            }}
                          >
                            -
                          </Button>
                          <Form.Control
                            type="number"
                            value={additionalUser}
                            disabled
                            className="text-center"
                             style={{
                              margin: "0px",
                            }}
                          />
                          <Button
                            variant="secondary"
                            onClick={() => increaseUser()}
                            disabled={!editBasePlan}
                            style={{
                              height: "42px",
                            }}
                          >
                            +
                          </Button>
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-0">
                      <Form.Label className="fw-semibold">
                        Price Per Additional User
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>$</InputGroup.Text>
                        <Form.Control
                          type="number"
                          value={pricePerAdditionalUser}
                          disabled={!editBasePlan}
                          onChange={(e) =>
                            setPricePerAdditionalUser(e.target.value)
                          }
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    {!editBasePlan ? (
                      <Button
                        variant="primary"
                        onClick={() => setEditBasePlan(!editBasePlan)}
                        className="w-100"
                      >
                        Edit
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        onClick={handleOnClickSave}
                        className="w-100"
                      >
                        Save
                      </Button>
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header>
                <h5 className="mb-0">Onboarding Setup</h5>
              </Card.Header>
              <Card.Body>
                <Row className="align-items-end">
                  <Col md={4}>
                    <Form.Group className="mb-0">
                      <Form.Label className="fw-semibold">
                        One-Time Setup Charge
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>$</InputGroup.Text>
                        <Form.Control
                          type="number"
                          onChange={(e) => setOneTimeCharge(e.target.value)}
                          value={oneTimeCharge}
                          disabled={!editOnBoarding}
                          style={{
                            margin: "0px",
                          }}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    {!editOnBoarding ? (
                      <Button
                        variant="primary"
                        onClick={() => setEditOnBoarding(!editOnBoarding)}
                        className="w-100"
                      >
                        Edit
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        onClick={handleOnClickSave}
                        className="w-100"
                      >
                        Save
                      </Button>
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header>
                <h5 className="mb-0">User Roles & Permissions</h5>
              </Card.Header>
              <Card.Body>
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group className="mb-0">
                      <Form.Label className="fw-semibold">
                        User Roles
                      </Form.Label>
                      <InputGroup>
                        {!addUserRoles ? (
                          <Form.Control
                            as="select"
                            onChange={(e) =>
                              handleSelectUserRole(e.target.value)
                            }
                          >
                            <option value="">Choose...</option>
                            {displaypTypeOptionsUserRoles()}
                          </Form.Control>
                        ) : (
                          <Form.Control
                            value={userRole}
                            onChange={(e) => setUserRole(e.target.value)}
                            placeholder="Enter role name"
                          />
                        )}
                        {!addUserRoles && !selectUserRole ? (
                          <Button
                            variant="primary"
                            onClick={() => setAddUserRoles(!addUserRoles)}
                          >
                            Add
                          </Button>
                        ) : !selectUserRole ? (
                          <Button
                            variant="success"
                            onClick={handleOnClickSaveUserRole}
                            disabled={!userRole}
                          >
                            Save
                          </Button>
                        ) : selectUserRole &&
                          !APP_DEFAULT_ROLES.includes(
                            allUserRole.find(
                              (role) => role._id === selectUserRole,
                            )?.name,
                          ) ? (
                          <Button
                            variant="danger"
                            onClick={handleOnClickDeleteUserRole}
                          >
                            Delete
                          </Button>
                        ) : null}
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={8}>
                    <Form.Group className="mb-0">
                      <Form.Label className="fw-semibold">
                        Select Permissions
                      </Form.Label>
                      <Select
                        isMulti
                        options={transformPermissionsToOptions(allPermision)}
                        value={selectPermision}
                        onChange={handlePermissionChange}
                        isDisabled={!selectUserRole}
                        placeholder="Select permissions..."
                        noOptionsMessage={() => "No permissions available"}
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                        formatOptionLabel={(option, { context }) => {
                          if (context === "menu") {
                            return option.label;
                          }
                          return option.combinedLabel || option.label;
                        }}
                        styles={{
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "rgba(0, 123, 255, 0.1)"
                              : state.isFocused
                                ? "rgba(0, 0, 0, 0.05)"
                                : "transparent",
                            color: "#333",
                            position: "relative",
                            paddingLeft: "30px",
                            "&::before": {
                              content: state.isSelected ? '"✓"' : '""',
                              position: "absolute",
                              left: "10px",
                              color: "#007bff",
                            },
                          }),
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="text-end">
                  <Button
                    variant="success"
                    onClick={handleOnClickSaveAdminPermision}
                    disabled={!selectUserRole || selectPermision.length === 0}
                  >
                    Save Permissions
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </div>
        )}
      </div>
    </MainComponent>
  );
};

export default Subscription;
